import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'el-icon-s-home', affix: true }
      }
    ]
  },
  // {
  //   path: "/DataStatistics",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       name: "DataStatistics",
  //       component: () => import("@/views/DataStatistics/index"),
  //       meta: { title: "数据统计", icon: "form" },
  //     },
  //   ],
  // },

  {
    path: '/AdManagement',
    component: Layout,
    children: [
      {
        path: 'AdManagement',
        name: 'AdManagement',
        component: () => import('@/views/AdManagement/index'),
        meta: { title: '首页管理', icon: 'form' }
      },
      {
        path: 'addBanner',
        name: 'addBanner',
        component: () => import('@/views/AdManagement/addBanner.vue'),
        meta: { title: '添加Banner' },
        breadcrumb: false,
        hidden: true
      },
      {
        path: 'editBanner',
        name: 'editBanner',
        component: () => import('@/views/AdManagement/addBanner.vue'),
        meta: { title: '编辑Banner' },
        breadcrumb: false,
        hidden: true
      }
    ]
  },

  {
    path: '/NewsManagement',
    component: Layout,
    redirect: '/NewsManagement/NewsList',
    name: 'NewsManagement',
    meta: { title: '动态管理', icon: 'form' },
    children: [
      {
        path: 'NewsList',
        name: 'NewsList',
        component: () => import('@/views/NewsList/index'),
        meta: { title: '内容列表', icon: 'form' }
      },
      {
        path: 'NewsCategories',
        name: 'NewsCategories',
        component: () => import('@/views/NewsCategories/index'),
        meta: { title: '内容分类', icon: 'form' }
      },
      {
        path: 'comments',
        name: 'comments',
        component: () => import('@/views/comments/index'),
        meta: { title: '评论管理', icon: 'form' }
      },
      {
        path: 'downloadResList',
        name: 'downloadResList',
        component: () => import('@/views/NewsList/downloadResList'),
        meta: { title: '下载审核', icon: 'form' }
      },
      {
        path: 'publish',
        name: 'publish',
        component: () => import('@/views/publish/index'),
        meta: { title: '发布资讯' },
        breadcrumb: false,
        hidden: true
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('@/components/uploads/test.vue'),
        // meta: { title: '发布资讯' },
        // breadcrumb: false,
        hidden: true
      }
    ]
  },
  {
    path: '/MeetingsEvent',
    component: Layout,
    name: 'MeetingsEvent',
    meta: { title: '会议和事件管理', icon: 'form' },
    children: [
      {
        path: 'meetings',
        name: 'meetings',
        component: () => import('@/views/EventMeeting/eventMeetingList'),
        meta: { title: '会议管理', icon: 'form', type: 'meeting' }
      },
      {
        path: 'creatMeetings',
        name: 'creatMeetings',
        component: () => import('@/views/EventMeeting/creatEventMeeting'),
        meta: { title: '创建会议', icon: 'form', type: 'meeting' },
        hidden: true
      },
      {
        path: 'events',
        name: 'events',
        component: () => import('@/views/EventMeeting/eventMeetingList'),
        meta: { title: '事件管理', icon: 'form', type: 'event' }
      },
      {
        path: 'creatEvents',
        name: 'creatEvents',
        component: () => import('@/views/EventMeeting/creatEventMeeting'),
        meta: { title: '创建事件', icon: 'form', type: 'event' },
        hidden: true
      },
      {
        path: 'infoList',
        name: 'infoList',
        component: () => import('@/views/EventMeeting/infoList'),
        meta: { title: '信息搜集', icon: 'form' }
      }
    ]
  },
  {
    path: '/Course',
    component: Layout,
    redirect: '/Course/course',
    name: 'CustomerNeeds',
    meta: { title: '公开课管理', icon: 'form' },
    children: [
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/Course/index'),
        meta: { title: '课程列表', icon: 'form' }
      },
      {
        path: 'addCourse',
        name: 'addCourse',
        component: () => import('@/views/Course/addCourse'),
        meta: { title: '添加公开课', icon: 'form' },
        hidden: true
      },
      {
        path: 'editCourse',
        name: 'editCourse',
        component: () => import('@/views/Course/addCourse'),
        meta: { title: '编辑公开课', icon: 'form' },
        hidden: true
      },
      {
        path: 'specialList',
        name: 'specialList',
        component: () => import('@/views/Course/specialList'),
        meta: { title: '专题列表', icon: 'form' }
      },
      {
        path: 'downloadResList',
        name: 'downloadResList',
        component: () => import('@/views/Course/downloadResList'),
        meta: { title: '下载审核', icon: 'form' }
      },
      {
        path: 'addSpecial',
        name: 'addSpecial',
        component: () => import('@/views/Course/addSpecial'),
        meta: { title: '添加专题', icon: 'form' },
        hidden: true
      },
      {
        path: 'editSpecial',
        name: 'editSpecial',
        component: () => import('@/views/Course/addSpecial'),
        meta: { title: '编辑专题', icon: 'form' },
        hidden: true
      },
      {
        path: 'sortCourse',
        name: 'sortCourse',
        component: () => import('@/views/Course/sortCourse'),
        meta: { title: '课程列表排序', icon: 'form' },
        hidden: true
      }
    ]
  },
  {
    path: '/CustomerNeeds',
    component: Layout,
    redirect: '/CustomerNeeds/ExpertClassification',
    name: 'CustomerNeeds',
    meta: { title: '服务管理', icon: 'form' },
    children: [
      {
        path: 'ExpertClassification',
        name: 'ExpertClassification',
        component: () => import('@/views/CustomerNeeds/index'),
        meta: { title: '专家分类', icon: 'form' }
      },
      {
        path: 'addExpert',
        name: 'addExpert',
        component: () => import('@/views/CustomerNeeds/addExpert'),
        meta: { title: '添加专家', icon: 'form' },
        hidden: true
      },
      {
        path: 'editExpert',
        name: 'editExpert',
        component: () => import('@/views/CustomerNeeds/addExpert'),
        meta: { title: '编辑专家', icon: 'form' },
        hidden: true
      },
      {
        path: 'NeedList',
        name: 'NeedList',
        component: () => import('@/views/CustomerNeeds/needList'),
        meta: { title: '信息收集', icon: 'form' }
      }
    ]
  },
  {
    path: '/Aboutus',
    name: 'Aboutus',
    component: Layout,
    meta: { title: '关于我们', icon: 'form' },
    children: [
      {
        path: 'aboutList',
        name: 'aboutList',
        component: () => import('@/views/Aboutus/aboutList'),
        meta: { title: '关于列表', icon: 'form' }
      },
      {
        path: 'addAbout',
        name: 'addAbout',
        component: () => import('@/views/Aboutus/addAbout'),
        meta: { title: '创建About', icon: 'form' }
        // hidden: true,
      },
      {
        path: 'editAbout',
        name: 'editAbout',
        component: () => import('@/views/Aboutus/addAbout'),
        meta: { title: '编辑About', icon: 'form' },
        hidden: true
      }
    ]
  },
  {
    path: '/userList',
    component: Layout,
    // redirect: '/UserManage/userList',
    // name: 'UserManage',
    // meta: { title: '用户管理', icon: 'form' },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/userManage/userList'),
        meta: { title: '账号权限管理', icon: 'form' }
      }
      //   {
      //     path: 'addUser',
      //     name: 'addUser',
      //     component: () => import('@/views/userManage/addUser'),
      //     meta: { title: '添加用户', icon: 'form' }
      //   },
      //   {
      //     path: 'userJurisdiction',
      //     name: 'userJurisdiction',
      //     component: () => import('@/views/userManage/userJurisdiction'),
      //     meta: { title: '阅读权限分组', icon: 'form' }
      //   }
    ]
  },
  {
    path: '/subscribes',
    component: Layout,
    redirect: '/subscribes/subscriptionList',
    name: 'subscribes',
    meta: { title: '订阅管理', icon: 'form' },
    children: [
      {
        path: 'subscriptionList',
        name: 'subscriptionList',
        component: () => import('@/views/subscribes/subscriptionList'),
        meta: { title: '订阅', icon: 'form' }
      },
      {
        path: 'preview',
        name: 'preview',
        component: () => import('@/views/subscribes/preview'),
        meta: { title: '预览', icon: 'form' },
        hidden: true
      },
      {
        path: 'emailFeedback',
        name: 'emailFeedback',
        component: () => import('@/views/subscribes/emailFeedback'),
        meta: { title: '反馈信息', icon: 'form' },
        hidden: true
      }
    ]
  },
  // {
  //   path: "/translate",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       name: "subscribes",
  //       component: () => import("@/views/translate/index"),
  //       meta: { title: "三翼鸟词组管理", icon: "form" },
  //     },
  //   ],
  // },

  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://panjiachen.github.io/vue-element-admin-site/#/',
  //       meta: { title: 'External Link', icon: 'link' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
